let audioContext: AudioContext | null = null;

export function getChatChimeContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  try {
    if (!audioContext) {
      const AC =
        window.AudioContext ||
        (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!AC) return null;
      audioContext = new AC();
    }
    return audioContext;
  } catch {
    return null;
  }
}

/** После клика/тапа — снимает блокировку автовоспроизведения у AudioContext. Не вызывать из useEffect без жеста. */
export async function unlockChatChime(): Promise<void> {
  const ctx = getChatChimeContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    await ctx.resume().catch(() => undefined);
  }
}

/**
 * Короткий сигнал о новом сообщении.
 * Не вызывает resume() без жеста пользователя — иначе Chrome пишет предупреждение в консоль;
 * звук играет только если контекст уже running (после unlockChatChime по первому касанию).
 */
export async function playChatChimeAsync(): Promise<void> {
  const ctx = getChatChimeContext();
  if (!ctx) return;
  if (ctx.state !== 'running') {
    return;
  }
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.value = 880;
    gain.gain.setValueAtTime(0.06, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.15);
  } catch {
    /* политика браузера */
  }
}
